import { hbs } from 'ember-cli-htmlbars';
export default hbs("{{@record.role.name}}")